import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-AzureFunction',
    templateUrl: './AzureFunction.component.html'
})
export class AzureFunctionComponent implements OnInit {

    consumerID: string;
    timeout = 60000;
    keepalive = 60000;
    https = true;
    https_verify = false;
    apikey: string;
    appname: string;
    hostdomain: string;
    clientid: string;
    routeprefix: string;
    functionname: string;
    runon = 'First';

    data = {
        'consumerID' : this.consumerID,
        'timeout' : this.timeout,
        'keepalive' : this.keepalive,
        'https' : this.https,
        'https_verify' : this.https_verify,
        'apikey' : this.apikey,
        'appname' : this.appname,
        'hostdomain' : this.hostdomain,
        'clientid' : this.clientid,
        'routeprefix' : this.routeprefix,
        'functionname' : this.functionname,
        'runon' : this.runon,
        'plugin' : 'azure-functions'
    };

    constructor() { }
    slider() {
        this.https = !this.https;
    }
    slider1() {
        this.https_verify = !this.https_verify;
    }

    Azure() {
    }
    ngOnInit() {
    }

}
